import { defineStore } from "pinia";
import _ from "lodash";
import { AddressFormState } from "@/shared/types";

export const initialState: AddressFormState = {
  saveDisabled: false,
  isValid: true
};

export const useAddressFormStore = defineStore("addressForm", {
  state: (): AddressFormState => (_.cloneDeep(initialState)),
  actions: {
    resetState () {
      this.saveDisabled = false;
      this.isValid = true;
    }
  }
});
